import { UIBox } from '@/components/ui/Box';
import { Typography } from '@/components/ui/Typography';
import { colors } from '@/theme';
import Checkbox from '@material-ui/core/Checkbox';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import styled from 'styled-components';

interface StyledListItemStatusProps {
  inUse?: boolean;
}

export const StyledListItem = styled(ListItem)`
  width: 100%;
  flex-wrap: wrap;
  padding: 20px 24px 14px 24px;
  background: #fbfbfb;
  border: 1px solid #ededed;
  border-radius: 4px;
  box-shadow: 0px -1px 8px 1px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;

  &&& {
    pointer-events: auto !important;
  }

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const StyledLeftHalf = styled(UIBox)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;

  ${({ theme }): string =>
    `${theme.breakpoints.down('sm')} {
            gap: 8px;
    }`}
  flex: 1;
`;
export const StyledRightHalf = styled(UIBox)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;

  ${({ theme }): string =>
    `${theme.breakpoints.down('sm')} {
            gap: 8px;
    }`}
  flex: 1;
`;

export const StyledListItemIcon = styled(ListItemIcon)`
  min-width: initial;
`;

export const StyledListItemCheckbox = styled(Checkbox)<{ disabled?: boolean }>`
  pointer-events: ${({ disabled }): string => (disabled ? 'none' : 'auto')};

  svg {
    fill: #005192;
  }
`;

export const StyledListItemInfo = styled(UIBox)<{ $isConfirmed?: boolean }>`
  margin-left: ${({ $isConfirmed }): string => {
    return $isConfirmed ? '0' : '16px';
  }};
  display: flex;
  flex-direction: column;
  width: 12%;
  min-width: 180px;
  align-items: flex-start;
`;

export const StyledListItemDate = styled(UIBox)`
  display: flex;
  align-items: center;

  span {
    color: #929496;
  }

  svg {
    width: 12px;
    height: 12px;
    margin-right: 4px;
    fill: #929496;
  }
`;

export const StyledListItemText = styled(UIBox)`
  display: flex;
  align-items: center;
  margin-top: 5px;

  svg {
    width: 18px;
    height: 18px;
    margin-right: 4px;
    fill: #929496;
  }
`;

export const StyleListItemBadge = styled(UIBox)`
  display: block;
  min-width: 80px;
  max-width: 80px;
  border-radius: 50px;
  text-align: center;
  justify-content: center;
  background: #707173;
  //margin-left: 24px;
  padding: 0 12px;
  height: 20px;

  span {
    line-height: 19px;
  }

  span {
    color: #fff;
  }
`;

export const StyledListItemStatus = styled(UIBox)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;

  ${({ theme }): string =>
    `${theme.breakpoints.down('sm')} {
            max-width: 130px;
    }`}
`;

export const StyledListItemStatusBadge = styled.div<StyledListItemStatusProps>`
  width: 16px;
  height: 16px;
  border-radius: 100%;
  margin-right: 14px;
  background: ${({ inUse }): string =>
    inUse ? '#F6BB3B' : '#417505'}; // TODO: use color variables
`;

export const StyledTinyListItemStatusBadge = styled(StyledListItemStatusBadge)`
  width: 12px;
  height: 12px;
  margin-right: 8px;
`;

export const StyledRealItemMessage = styled(Typography)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100px;
  min-width: 100px;
`;

export const StyledLink = styled(Typography)`
  color: ${colors.primary} !important;
  text-decoration: underline;
  text-underline-offset: 4px;
  padding: 8px 24px;
`;

export const StyledListItemStatusText = styled(Typography)`
  text-align: right;

  ${({ theme }): string =>
    `${theme.breakpoints.down('xs')} {
      text-align: left;
    }`}
`;

export const StyledListItemStatusIcon = styled(UIBox)<{
  $backgroundColor: string;
}>`
  width: 28px;
  height: 28px;
  max-width: 28px;
  max-height: 28px;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  background: ${({ $backgroundColor }): string => $backgroundColor};
  flex-shrink: 0;
  margin-left: 16px;

  svg {
    width: 18px;
    height: 18px;
    fill: ${colors.white};
  }
  flex-grow: 1;

  ${({ theme }): string =>
    `${theme.breakpoints.down('sm')} {
     max-width: 28px;
  max-height: 28px;
   }`}
`;
//#endregion
